import { ICellRendererParams } from 'ag-grid-enterprise'

import { cn } from '@fortem-monorepo/js-utilities'
import { createColDefs } from '@fortem-monorepo/react-ag'
import { CustomAgGrid } from '@fortem-monorepo/react-ag'

import { ICReportTablePrimitive } from '@/pages/funds/ic-report/components/primitives/types'
import { fundLevel } from '@/react-query/queries/ic-report/hooks'

const colDefs = createColDefs([
  {
    field: 'description',
    headerName: 'Description',
    cellRenderer: (params: ICellRendererParams) => {
      return params?.node.level === -1 ? (
        <span className={'font-semibold'}>Total</span>
      ) : (
        params.value
      )
    },
  },
  {
    field: 'new_value',
    headerName: 'Cost to unwind T',
    aggFunc: 'sum',
    cellRenderer: (params: ICellRendererParams) => {
      const val = (params?.value ?? 0.0) * 100
      const formattedVal = `${val.toFixed(2)}%`

      return (
        <span
          className={cn({
            ['font-semibold']: params?.node.level === -1,
          })}
        >
          {formattedVal}
        </span>
      )
    },
  },
  {
    field: 'old_value',
    headerName: 'Cost to unwind T-1',
    aggFunc: 'sum',
    cellRenderer: (params: ICellRendererParams) => {
      const val = (params?.value ?? 0.0) * 100
      const formattedVal = `${val.toFixed(2)}%`

      return (
        <span
          className={cn({
            ['font-semibold']: params?.node.level === -1,
          })}
        >
          {formattedVal}
        </span>
      )
    },
  },
])

export interface LiquidityReportingTableProps extends ICReportTablePrimitive {}

export const LiquidityReportingTable: React.FC<LiquidityReportingTableProps> = ({
  params,
  options,
}) => {
  const query = fundLevel.useLiquidityReporting(params)
  const data = query.data

  return <CustomAgGrid rowData={data} columnDefs={colDefs} grandTotalRow={'bottom'} {...options} />
}
